import PageHeader from "../components/PageHeader";
import GlobalTradeNetwork from "../components/GlobalTradeNetwork";
import CTABanner from "../components/CTABanner";
import { MARKETS } from "../lib/content";
import { motion } from "framer-motion";

export default function Markets() {
  return (
    <div data-testid="markets-page">
      <PageHeader
        eyebrow="Markets"
        title="A global trade network."
        subtitle="BNM Group connects suppliers and buyers across strategic international markets — Europe, the Middle East, Central Asia and Africa."
        image="https://static.prod-images.emergentagent.com/jobs/992269a5-240d-47a2-94bf-57af67715604/images/107173358a58b4fd951837fe4813b7bcfbd17e66dd1538255a609f5864d5d57d.png"
        testId="markets-page-header"
      />

      <GlobalTradeNetwork />

      <section className="py-20 sm:py-28 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-10">
          {MARKETS.map((m, i) => (
            <motion.div
              key={m.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 2) * 0.1 }}
              className="bg-white border border-[#E3E6EC] p-10 hover-lift"
              data-testid={`market-card-${m.id}`}
            >
              <div className="flex items-center gap-3 mb-4">
                <span className="w-10 h-px bg-[#F37021]" />
                <span className="text-eyebrow text-[#F37021]">Region 0{i + 1}</span>
              </div>
              <h3 className="font-display font-black tracking-tighter text-3xl sm:text-4xl text-[#0A1F3F]">
                {m.name}
              </h3>
              <p className="mt-5 text-base text-[#4B5668] leading-relaxed">{m.summary}</p>
              <div className="mt-7 flex flex-wrap gap-2">
                {m.countries.map((c) => (
                  <span
                    key={c}
                    className="text-xs uppercase tracking-[0.15em] font-semibold px-3 py-2 bg-[#F4F5F8] text-[#0A1F3F]"
                  >
                    {c}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      <CTABanner />
    </div>
  );
}
